import { AlertColor, Snackbar } from '@mui/material';
import { Alert } from '@mui/material';

export interface SnackBarMessageProps {
    open: boolean,
    duration?: number,
    message: string,
    subMessage?: string,
    severity?: AlertColor,
    onClose: () => void
}

export const SnackBarMessage = (props: SnackBarMessageProps) => {
    return (
        <div>
            <Snackbar open={props.open} autoHideDuration={props.duration || 6000} onClose={() => props.onClose()}
                anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                sx={{ height: 'auto', whiteSpace: 'pre-line' }}>
                <Alert onClose={() => props.onClose()} severity={props.severity}>
                    {props.message}
                    {props.subMessage !== undefined || props.subMessage !== null ? (<br />) : (<div></div>)}
                    {props.subMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};